import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { useWorkspaces } from "@/lib/queries";
import { getLastWorkspaceId, setLastWorkspaceId } from "@/lib/workspacePref";
import styles from "./AppHome.module.css";

/**
 * /app entry resolver. Sends the user to their last-viewed workspace
 * (or the first one they belong to). If they have no workspaces yet,
 * routes to the create-workspace flow.
 */
export function AppHome() {
  const auth = useAuth();
  const navigate = useNavigate();
  const workspacesQuery = useWorkspaces();

  const workspaces = workspacesQuery.data?.workspaces;

  useEffect(() => {
    if (!workspaces) return;
    if (workspaces.length === 0) {
      navigate("/app/new-workspace", { replace: true });
      return;
    }
    const last = getLastWorkspaceId();
    const target = workspaces.find((w) => w.id === last) ?? workspaces[0];
    if (target) {
      setLastWorkspaceId(target.id);
      navigate(`/w/${target.id}`, { replace: true });
    }
  }, [workspaces, navigate]);

  if (auth.status === "loading") {
    return <div className={styles.center}>Loading…</div>;
  }
  if (auth.status === "anonymous") {
    return <Navigate to="/signin?next=/app" replace />;
  }
  if (workspacesQuery.error) {
    return (
      <div className={styles.center}>
        <p>Couldn’t load your workspaces.</p>
        <p className={styles.muted}>{workspacesQuery.error.message}</p>
      </div>
    );
  }
  return <div className={styles.center}>Loading your workspace…</div>;
}
